import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import { keyframes, style } from '@vanilla-extract/css';

const shimmerKeyframes = keyframes({
  '0%': {
    backgroundPosition: '200% 0',
  },
  '100%': {
    backgroundPosition: '-200% 0',
  },
});

export const shimmerText = style(
  {
    background: `linear-gradient(90deg,
    ${themeVars.color['text-primary']} 0%,
    ${themeVars.color['text-secondary']} 50%,
    ${themeVars.color['text-primary']} 100%)`,
    backgroundSize: '200% auto',
    color: 'transparent',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    animation: `${shimmerKeyframes} 2s linear infinite`,
    display: 'inline-block',
  },
  'shimmer-text',
);

/**
 * Derive a theme-agnostic ink from an AI ring stop. The ring stops are the same
 * value in both themes, which reads pale on light backgrounds, so mix each stop
 * toward `text-primary` -- gray-950 in light, gray-50 in dark -- and the one
 * expression darkens on light and lightens on dark.
 *
 * Mix in oklab, not oklch: oklch interpolates hue, and `text-primary` is not
 * perfectly achromatic, so the stops would drift toward its hue (violet 290 ->
 * 335). oklab scales a and b together instead, which preserves hue and only
 * shrinks chroma -- and the `l 0.16 h` pin puts that chroma back.
 *
 * 55% is the mix amount where both stops clear WCAG AA (4.5:1) against the
 * light content plane.
 *
 * TODO: replace with a Pluma helper / dedicated AI text tokens once they exist.
 */
const ink = (color: string) =>
  `oklch(from color-mix(in oklab, ${color} 55%, ${themeVars.color['text-primary']}) l 0.16 h)`;

export const shimmerTextGradient = style(
  {
    background: `linear-gradient(90deg,
    ${ink(themeVars.color['ai-ring-stop-03'])} 0%,
    ${ink(themeVars.color['ai-ring-stop-02'])} 50%,
    ${ink(themeVars.color['ai-ring-stop-03'])} 100%)`,
    backgroundSize: '200% auto',
    color: 'transparent',
    WebkitBackgroundClip: 'text',
    backgroundClip: 'text',
    animation: `${shimmerKeyframes} 2s linear infinite`,
    display: 'inline-block',
  },
  'shimmer-text-gradient',
);
